import Cookies from 'js-cookie';

const cookiePreferencesNames = [
  'analytics_storage', // consent to store cookies and such for analytics
  'ad_personalization', // consent for user data to be used ads personalization
  'ad_storage', // consent to store cookies and such for advertising
  'ad_user_data', // consent for user data be used for re-marketing
];
window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}

function initMainBanner() {
  const cookieBanner = document.querySelector('#cookie-banner');
  if (!cookieBanner) {
    return;
  }
  const preferencesSection = document.querySelector(
    '#cookie-banner-preferences',
  );
  const rejectAllBtn = document.querySelector('#reject-cookies');
  const acceptAllBtn = document.querySelector('#accept-cookies');
  const savePreferencesBtn = document.querySelector('#save-preferences');
  const cookiePreferencesBtn = document.querySelector('#cookie-preferences');
  const mainCookieSection = document.querySelector('#main-cookie-banner');
  const closeBtn = document.querySelector('#cookie-banner-close');

  cookiePreferencesBtn.addEventListener('click', () => {
    loadPreferences();
    preferencesSection.classList.remove('hidden');
    savePreferencesBtn.classList.remove('hidden');
    cookiePreferencesBtn.classList.add('hidden');
    mainCookieSection.classList.add('hidden');
  });

  rejectAllBtn.addEventListener('click', () => {
    setCookiePreferencesAndHideBanner('denied');
  });

  acceptAllBtn.addEventListener('click', () => {
    setCookiePreferencesAndHideBanner('granted');
  });

  function setCookieConsentAndHideBanner() {
    Cookies.set('cookie_consent_set', true, { path: '/', expires: 365 });
    hideBanner();
  }

  function setCookiePreferencesAndHideBanner(permission = 'granted') {
    cookiePreferencesNames.forEach((cookieName) => {
      Cookies.set(cookieName, permission, { path: '/', expires: 365 });
    });
    setCookieConsentAndHideBanner();
    gtag('consent', 'update', {
      analytics_storage: permission,
      ad_personalization: permission,
      ad_storage: permission,
      ad_user_data: permission,
    });
  }

  closeBtn.addEventListener('click', () => {
    setCookieConsentAndHideBanner();
  });

  savePreferencesBtn.addEventListener('click', () => {
    setPreferences();
    setCookieConsentAndHideBanner();
  });

  function setPreferences() {
    const cookiePreferences = {};
    preferencesSection
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => {
        const cookieName = checkbox.name;
        if (cookieName === 'essential') return;
        const cookieValue = checkbox.checked ? 'granted' : 'denied';
        Cookies.set(cookieName, cookieValue, { path: '/', expires: 365 });
        cookiePreferences[cookieName] = cookieValue;
      });
    gtag('consent', 'update', cookiePreferences);
  }

  function loadPreferences() {
    cookiePreferencesNames.forEach((cookieName) => {
      const cookieValue = Cookies.get(cookieName);
      document.querySelector(`input[name="${cookieName}"]`).checked =
        cookieValue === 'granted';
    });
  }

  function hideBanner() {
    preferencesSection.classList.add('hidden');
    savePreferencesBtn.classList.add('hidden');
    cookiePreferencesBtn.classList.remove('hidden');
    mainCookieSection.classList.remove('hidden');
    cookieBanner.classList.add('hidden');
    cookieBanner.classList.remove('flex');
  }

  loadPreferences();
}

function initBannerOpen() {
  const openBannerBtns = document.querySelectorAll('.open-cookie-banner');
  openBannerBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const cookieBanner = document.querySelector('#cookie-banner');
      if (!cookieBanner) {
        console.error('Cookie banner not found');
        return;
      }
      cookieBanner.classList.remove('hidden');
      cookieBanner.classList.add('flex');
    });
  });
}

function updateCookieConsent() {
  const preferences = {};
  cookiePreferencesNames.forEach((cookieName) => {
    const cookieValue = Cookies.get(cookieName);
    if (!cookieValue) return;
    preferences[cookieName] = cookieValue;
  });
  if (Object.keys(preferences).length === 0) return;
  gtag('consent', 'update', preferences);
}

export default function initCookieBanner() {
  initMainBanner();
  initBannerOpen();
  updateCookieConsent();
}
